'use strict';

var form = document.querySelector('#calculator');
var tipAmount = document.querySelector('.tip-amount');
var totalAmount = document.querySelector('.total-amount');

function tipCalculator(e) {
  e.preventDefault();
  var bill = parseFloat(this.bill.value);
  var percent = parseInt(this.service.value);
  var calculatedTip = bill / 100 * percent;
  var calculatedTotal = bill + calculatedTip;
  tipAmount.innerHTML = Math.round(calculatedTip);
  totalAmount.innerHTML = Math.round(calculatedTotal);
  this.reset();
}

form.addEventListener('submit', tipCalculator);